import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SumTotalTicketsPipe } from './sum-total-tickets.pipe';

@NgModule({
  declarations: [SumTotalTicketsPipe],
  imports: [CommonModule],
  exports: [SumTotalTicketsPipe]
})
export class SumTotalTicketsPipeModule {}
